require('./../teamSubscriptionPurchaseForm/teamSubscriptionPurchaseController');
require('../../pricing/plans/planCardDirective');

"use strict";

angular.module('app.purchase.purchaseForm.teamPurchaseFormDirective', [
  'app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController',
  'app.pricing.plans.planCardDirective',
])
  .directive('teamPurchaseForm', [
    function () {
      return {
        restrict: 'EA',
        templateUrl: 'components/purchase/teamSubscriptionPurchaseForm/teamSubscriptionPurchaseView.html',
        controller: 'app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController',
        scope: {
          showManage: '<?',
          plans: '<',
          currentSubscription: '<?',
          fetchSubscription: '<?',
          fetchPlans: '<?',
          useServiceBreaker: '<?'
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/teamSubscriptionPurchaseForm/teamSubscriptionPurchaseDirective.js